import React from 'react';
import { Button, Card, Typography, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import strings from 'strings';

const ThankYou = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.replace('/login'); // Prevents back navigation to form
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="var(--bg-canvas)">
      <Card style={{ padding: '2rem', maxWidth: 400, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <Typography variant="h4" gutterBottom color="primary">
          {strings.THANK_YOU_TITLE}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {strings.THANK_YOU_BODY}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: '2rem', width: '100%' }}
          onClick={handleGoHome}
        >
          {strings.THANK_YOU_BUTTON}
        </Button>
      </Card>
    </Box>
  );
};

export default ThankYou;
